import React from 'react';
import Text, { TEXT_VARIANTS } from 'components/ui/Typography/Text';
import AIAlert from 'components/shared/AI/AlAlert';
import Selections from 'components/shared/AI/Selections';
import BrowsingSvg from './svg/BrowsingSvg';
import { LESSON_CONTENT_TYPES_CHOICES, LESSON_TYPES } from './constants';

const InitialInformation = ({
  lessonType,
  setLessonType,
  lessonContent,
  setLessonContent,
  isJointUser,
}) => {
  const LESSON_TYPES_CHOICES = [
    {
      text: isJointUser
        ? t('actions.lesson_generate_modal.lesson_content')
        : t('actions.lesson_generate_modal.give_text_content'),
      value: LESSON_TYPES.CONTENT,
    },
    {
      text: t('actions.lesson_generate_modal.lesson_topic'),
      value: LESSON_TYPES.TOPIC,
    },
  ];

  return (
    <>
      <AIAlert tooltipText={t('actions.ai.lesson_generator_tooltip')} />
      <BrowsingSvg />
      <Text
        variant={TEXT_VARIANTS.BODY_LIGHT}
        className="lesson-generate-label"
        component="div"
      >
        {t('actions.lesson_generate_modal.type_to_generate')}
      </Text>
      <Selections
        selections={LESSON_TYPES_CHOICES}
        selection={lessonType}
        setSelection={setLessonType}
      />
      {isJointUser && lessonType === LESSON_TYPES.CONTENT && (
        <>
          <Text
            variant={TEXT_VARIANTS.BODY_LIGHT}
            className="lesson-generate-label mt-18"
            component="div"
          >
            {t('actions.lesson_generate_modal.provide_content_label')}
          </Text>
          <Selections
            selections={LESSON_CONTENT_TYPES_CHOICES}
            selection={lessonContent}
            setSelection={setLessonContent}
          />
        </>
      )}
    </>
  );
};

export default InitialInformation;
